import { createFileRoute } from '@tanstack/react-router'
import { ScrollText } from 'lucide-react'
import { z } from 'zod'
import { ManifestsScreen } from '@/screens/investigate/SCR-014-manifests'

export const Route = createFileRoute('/_app/w/$ws/manifests')({
  staticData: { screen: { id: 'SCR-014', title: 'Context manifests', group: 'Investigate', perm: 'trace.read', order: 2, description: 'Every context ESM delivered: what, to whom, when, with which channels and exactly how many tokens.', icon: ScrollText } },
  validateSearch: z.object({
    manifest: z.string().max(200).optional(),
    workspace: z.enum(['this', 'all']).optional().catch(undefined),
    principal: z.string().max(200).optional(),
    key: z.string().max(200).optional(),
    purpose: z.string().max(80).optional(),
    q: z.string().max(200).optional(),
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().catch(undefined),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().catch(undefined),
    degraded: z.enum(['true', 'false']).optional().catch(undefined),
    channel: z.enum(['keyword', 'semantic', 'temporal', 'table', 'entity', 'graph']).optional().catch(undefined),
    channel_status: z.enum(['ok', 'empty', 'failed', 'not_available']).optional().catch(undefined),
    simulated: z.enum(['exclude', 'include', 'only']).optional().catch(undefined),
    outcome: z.enum(['up', 'down', 'none']).optional().catch(undefined),
  }),
  component: ManifestsScreen,
})
